import { atom } from "jotai";

export type CalendarId = {
    appointments: string, 
    availability?: "primary" | string
}

// props of calendar
export const calendarIdAtom = atom<CalendarId | null>(null)
export const eventIdAtom = atom("")


// export const _calendarIdAtom = atom(
//     (get) => {
//         return get(calendarIdAtom)
//     },
//     (get, set, newCalendarId: string) => {
//         set(calendarIdAtom, newCalendarId)
//     }
// )


// _calendarIdAtom.onMount = (setAtom) => {
// roleAtom.onMount = (setAtom) => {

// }


// function getOrCreateCalendar() {
    
// }